// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fi{font-family:fontello;display:flex}.fi.fi-2x{font-size:1.5em}.fi.fi-3x{font-size:2em}.fi.fi-4x{font-size:2.5em}.fi.fi-5x{font-size:3em}.span-remove-src-img{color:#d90b3b;font-size:10px;cursor:pointer}#datatable-matrix-backoffice tr{height:42px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
